import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { CommaPipe } from 'src/app/pipes/comma.pipe';
import { DateTimeService } from '../date-time.service';
import { RelationsService } from '../relations.service';
import { CIKService, Transaction } from './cik.service';
import { fade } from '../shared/animations';

@Component({
  selector: 'app-cik',
  templateUrl: './cik.component.html',
  styleUrls: ['./cik.component.scss'],
  animations: [fade]
})
export class CikComponent implements OnInit, OnDestroy {
  cikSubscription: Subscription;
  cikTransactions = [];
  totalCIK: string;
  totalCIKPos: boolean;
  message = 'Recent Filings loading...';
  ready;

  constructor(
    private cikService: CIKService,
    private commaPipe: CommaPipe,
    private cdr: ChangeDetectorRef,
    public dtService: DateTimeService,
    public relationsService: RelationsService
  ) { }

  ngOnInit(): void {
    this.cikSubscription = this.cikService.cikSubject$
      .pipe(
        map((res: any) => {
          if (typeof res === 'string') {
            this.message = 'Recent Filings: ' + res;
            return;
          } else if (!res) {
            console.log('no res: ', res);
            return;
          }
          // tslint:disable-next-line: no-string-literal
          // handle positive and negative values
          this.cikTransactions = res.items;
          const sum = this.sum(this.cikTransactions, 'transactionValue');
          this.totalCIK = this.commaPipe.transform((sum));
          this.totalCIKPos = sum < 0 ? false : true;
          return res;
        })
      )
      .subscribe(
        res => {
          if (!res) {
            return;
          }
          this.cikTransactions = res.items;
          this.message = 'Recent Filings';
          setTimeout(() => {
            this.ready = true;
          }, 100);
          this.cdr.detectChanges();
        },
        err => this.message = 'Recent Filings: ' + err
      );
  }

  posToNeg(num) {
    return -Math.abs(num);
  }

  sum(items, prop) {
    const copied = [...items];
    copied.forEach(item => {
      if (item.transactionCode === 'S') {
        item.transactionValue = this.posToNeg(item.transactionValue);
      }
    });
    return copied.reduce((a, b) => {
      return a + b[prop];
    }, 0);
  }

  getRelations(tr) {
    return this.relationsService.concatRelations(tr, 'comma');
  }

  rowClicked(tr: Transaction) {
    window.open(tr.linkHtm, '_blank');
  }

  ngOnDestroy() {
    this.cikTransactions = [];
    this.cikSubscription.unsubscribe();
  }
}
